import { useEffect } from 'react';

import { IUseAlertOrderDeliveryMinimum } from './types';

const useAlertOrderDeliveryMinimum = ({
  calculateCartTotal,
  checkoutDeliveryPriceMinimum,
  setCartPriceTooLow,
  isDelivery,
}: IUseAlertOrderDeliveryMinimum) => {
  useEffect(() => {
    if (!isDelivery) {
      setCartPriceTooLow(false);
      return;
    }

    setCartPriceTooLow(calculateCartTotal() < checkoutDeliveryPriceMinimum);
  }, [calculateCartTotal, checkoutDeliveryPriceMinimum, isDelivery, setCartPriceTooLow]);
};

export default useAlertOrderDeliveryMinimum;
